/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUploadAssetUrlBody
 */
export interface GetUploadAssetUrlBody {
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlBody
     */
    contentType: string;
}

/**
 * Check if a given object implements the GetUploadAssetUrlBody interface.
 */
export function instanceOfGetUploadAssetUrlBody(value: object): value is GetUploadAssetUrlBody {
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function GetUploadAssetUrlBodyFromJSON(json: any): GetUploadAssetUrlBody {
    return GetUploadAssetUrlBodyFromJSONTyped(json, false);
}

export function GetUploadAssetUrlBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUploadAssetUrlBody {
    if (json == null) {
        return json;
    }
    return {
        
        'contentType': json['contentType'],
    };
}

export function GetUploadAssetUrlBodyToJSON(json: any): GetUploadAssetUrlBody {
    return GetUploadAssetUrlBodyToJSONTyped(json, false);
}

export function GetUploadAssetUrlBodyToJSONTyped(value?: GetUploadAssetUrlBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contentType': value['contentType'],
    };
}

